<template>
    <button
        :disabled="buttonDisabled || loading"
        :autofocus="autofocus"
        :type="nativeType"
        :class="[
            type ? 'app-button--' + type : '',
            buttonSize ? 'app-button--' + buttonSize : '',
            {
                'is-disabled': buttonDisabled,
                'is-loading': loading,
                'is-plain': plain,
                'is-bordered': border,
                'prepend': prepend,
                'append': append
            }
        ]"
        class="app-button"
        @click="handleClick">
        <i v-if="loading" class="app-icon-loading" />
        <i v-if="icon && !loading" :class="icon" class="icon" />
        <span v-if="$slots.default">
            <slot />
        </span>
    </button>
</template>

<script>
export default {
    name: 'app-button',
    inject: {
        elForm: {
            default: ''
        },
        elFormItem: {
            default: ''
        }
    },
    props: {
        type: {
            type: String,
            default: 'default'
        },
        size: String,
        icon: {
            type: String,
            default: ''
        },
        nativeType: {
            type: String,
            default: 'button'
        },
        loading: Boolean,
        disabled: Boolean,
        plain: Boolean,
        prepend: Boolean,
        append: Boolean,
        border: {
            type: Boolean,
            default: true
        },
        autofocus: Boolean
    },
    computed: {
        buttonSize() {
            return (
                this.size || this._elFormItemSize || (this.$ELEMENT || {}).size
            )
        },
        buttonDisabled() {
            return this.disabled || (this.elForm || {}).disabled
        }
    },
    methods: {
        handleClick(evt) {
            this.$emit('click', evt)
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

.app-button
    display: inline-block
    line-height: 1
    white-space: nowrap
    cursor: pointer
    background: $light-blue
    border: 0px solid alpha($dark-blue, 0.05)
    color: $dark-blue
    -webkit-appearance: none
    text-align: center
    box-sizing: border-box
    outline: 0
    margin: 0
    transition: 0.1s
    font-weight: 500
    padding: 11px 20px
    font-size: 13px
    border-radius: 18px

    &:hover
        background: $dark-blue
        border-color: $dark-blue
        color: $white

        .icon
            color: $white

    &:focus
        color: $dark-blue
        border-color: $dark-blue

    &.app-button--primary
        background: $dark-blue
        border-color: $dark-blue
        color: $white

        &:hover, &:focus
            background: $darker-blue
            color: $white

    &.app-button--clear
        background: $white
        border-color: $border-color
        color: $darker-blue

        &:hover, &:focus
            border-color: $darker-blue
            background: $darker-blue
            color: $white

    &.app-button--success
        background: $light-green
        border-color: $light-green
        color: $dark-green

        &.is-plain
            color: $dark-green

        &:hover, &:focus
            background: $dark-green
            color: $white

    &.app-button--danger
        background: $light-red
        border-color: alpha($dark-red, 0.05)
        color: $dark-red

        &.is-plain
            color: $dark-red

        &:hover, &:focus
            background: $dark-red
            color: $white

            &.is-plain
                background: $dark-red
                color: $white

    &.app-button--extra-large
        font-size: 16px
        padding: 15px 20px
        border-radius: 24px
        text-transform: uppercase
        font-weight: bold

    &.app-button--large
        font-size: 14px
        padding: 12px 20px
        border-radius: 20px

    &.app-button--small
        padding: 8px 14px
        border-radius: 15px
        font-size: 12px
        font-weight: 700

    &.app-button--mini
        padding: 6px 12px
        border-radius: 12px
        font-size: 10px

    &.is-plain
        background: transparent
        border-width: 0px
        border-color: transparent
        font-weight: 700

    &.is-bordered
        border-width: 1px

    &.is-loading
        padding-right: 40px
        position: relative

        &:before
            content: ''
            position: absolute
            display: block
            width: 0px
            height: 0px
            border-radius: 50%
            right: 10px
            top: 50%
            border: 2px solid rgba(255, 255, 255, 0.4)
            border-right: 2px solid $white
            animation: rotate360 0.5s infinite linear, exist 0.1s forwards ease

    &.prepend
        border-top-right-radius: 0px
        border-bottom-right-radius: 0px
        margin-right: -4px
        position: relative
        z-index: 1

    &.append
        border-top-left-radius: 0px
        border-bottom-left-radius: 0px
        margin-left: -4px
        position: relative
        z-index: 1

    @keyframes rotate360
        100%
            transform: rotate(360deg)

    @keyframes exist
        100%
            width: 12px
            height: 12px
            margin: -8px 5px 0 0
</style>